import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useState } from 'react';

export type DateOfDeathInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  required: boolean;
  label: string;
};

export function DateOfDeathInput({
  value,
  onChange,
  required,
  label,
}: DateOfDeathInputProps) {
  const [dateOfDeath, setDateOfDeath] = useState(value ? dayjs(value) : null);

  const updateFormDateOfDeath = (newValue: dayjs.Dayjs | null) => {
    const newDateOfDeath = newValue?.isValid()
      ? newValue?.format('YYYY-MM-DD').split('T')[0]
      : null;

    if (newDateOfDeath === value) {
      return;
    }

    onChange(newDateOfDeath);
  };
  return (
    <DatePicker
      label={label}
      disableFuture
      openTo='year'
      views={['year', 'month', 'day']}
      value={dateOfDeath}
      onChange={newValue => {
        setDateOfDeath(newValue);
        updateFormDateOfDeath(newValue);
      }}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          required,
        },
      }}
    />
  );
}
